import { Divider, List, Typography, Grid } from '@material-ui/core';
import React from 'react';
import { AppRouteURI } from "router/RoleBasedAccess";
import useStyles from '../Styles';
import { useHistory } from "react-router";
import { useSelector } from 'react-redux';
import userActions from "components/TechnicalView/actions";

const pages = [
    {
      title: 'Colorado River Water Access',
      route: AppRouteURI.VISUALIZATIONS + '/map',
      chart: 'colorado_river_access',
      name: 'colarado_river_water_access',
    },
    {
      title: 'Central Arizona Colorado River Water Access Per Person - Municipal Areas',
      route: AppRouteURI.VISUALIZATIONS + '/honeycomb',
      chart: 'access_per_capita',
      name: 'central_arizona_colorado_river_water_access_per_person_municipal_areas',
    },
    {
      title: 'Central Arizona Water Deliveries and Uses - 2020',
      route: AppRouteURI.VISUALIZATIONS + '/doughnut?type=cities&dropdown=phoenix',
      chart: 'central_az_water_use',
      name: 'central_arizona_water_deliveries_and_uses',
    },
    {
      title: 'Colorado River Access by Water Priority Level',
      route: AppRouteURI.VISUALIZATIONS + '/area',
      chart: 'colorado_river_water_access',
      name: 'colorado_river_access_by_water_priority_level',
    },
    {
      title: 'Central Arizona Colorado River Water Use vs. Access',
      route: AppRouteURI.VISUALIZATIONS + '/gauge',
      chart: 'water_use_versus_access',
      name: 'central_arizona_colorado_river_water_use_vs_access',
    },
];

const LeftDrawer = ({ onClose }) => {
    const classes = useStyles();
    const history = useHistory();
    const { chart, city_selected, western_arizona_selected, tribe_selected, is_city, is_tribe, is_western, irrigation_district_selected } = useSelector((state) => state.technical_view);
    let params = new URLSearchParams(history?.location?.search)
    const { features } = useSelector((state) => state?.featureSettings)
    const { setChart } = userActions();

    const changeVisualization = (page) => {
      if (chart !== page.chart) {
        setChart(page.chart);

        switch (page.chart) {
          case 'colorado_river_access':
            let dropdownParams = is_city ? {type: 'cities', dropdown: city_selected?.name} : is_tribe ? { type: 'tribe', dropdown: tribe_selected?.name } : {name: 'irrigation_district' , dropdown: western_arizona_selected?.name}
            // includes all entities of types Western Arizona, Irrigation Districts, and Cities.
            history.push({
              pathname: `/visualizations/map`,
              search:  "?" + new URLSearchParams(dropdownParams).toString(),
            });
            break;
          case 'access_per_capita':
            // includes  Cities entity
            history.push({
              pathname: '/visualizations/honeycomb',
              search:  "?" + new URLSearchParams({ type: "cities", dropdown: city_selected?.name || "Phoenix" }).toString(),
            });
            break;
          case 'central_az_water_use':
            // Cities tab: Cities , Irrigations tab : Irrigation
            let obj = is_western ? {type: 'irrigation_district', dropdown: irrigation_district_selected?.name} : {type: 'cities', dropdown: city_selected?.name}
            history.push({
              pathname: `/visualizations/doughnut`,
              search:  "?" + new URLSearchParams(obj).toString(),
            });
            break;
          case 'colorado_river_water_access':
            // includes all entities of types Western Arizona, Irrigation Districts, and Cities.
            history.push({
              pathname: `/visualizations/area`,
              search:  "?" + new URLSearchParams({type: params.get('type') || "cities", dropdown: params.get('dropdown') || "Phoenix"}).toString(),
            });
            break;
          case 'water_use_versus_access':
            // includes  Cities entity
            history.push({
              pathname: `/visualizations/gauge`,
              search:  "?" + new URLSearchParams({ type: "cities", dropdown: city_selected?.name || "Phoenix" }).toString(),
            });
            break;
          default:
            break;
        }
        onClose();
      }
    }
    const featureSettingFilter = pages.filter((page) => features[page?.name] === true)

    return (
        <List style={{ paddingTop: 140 }}>
            {featureSettingFilter.map((page, index) => {
                return (
                  <React.Fragment key={"left-drawer-item-"+index}>
                    <Grid
                      item
                      container
                      justify='space-between'
                      alignItems='center'
                      key={"left-drawer-item-"+index}
                      style={{ textDecoration: 'none' }}
                      onClick={() => changeVisualization(page)}
                    >
                      <Typography className={classes.drawerHeaderText}>{page.title}</Typography>
                    </Grid>
                    <Divider />
                  </React.Fragment>
                )
            })}
        </List>
    )
}

export default LeftDrawer;
